export const handleCreateGiftCardResponse = (
  response,
  setLastRequestState,
  navigate,
  sender,
  recipient,
  paymentInformation,
) => {
  const serviceError = {
    errorPaymentMessage: '',
    showRetry: true,
    isLoading: false,
  };
  if (response.ok) {
    return response.text().then((text) => {
      let data = {};
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('Something went wrong', e);
        setLastRequestState(serviceError);
        return;
      }
      if (!window?.dataLayer) {
        window.dataLayer = [];
      }
      window.dataLayer.push({
        event: 'giftcard_purchase',
        ...data,
      });
      const pathname = `${window.location.pathname.includes('gifting') ? '/gifting' : ''}/gift-card-confirm`;
      navigate(pathname, {
        state: {
          response: data,
          sender,
          recipient,
          paymentInformation,
        },
      });
    });
  } else if (response.status === 422) {
    return response
      .json()
      .then((body) => {
        if (body.is_transaction_error) {
          setLastRequestState({
            errorPaymentMessage: body.customer_message,
            showRetry: false,
            isLoading: false,
          });
        } else {
          console.error('It is a 422 but It is not a transaction_error', response);
          setLastRequestState(serviceError);
        }
      })
      .catch((error) => {
        console.error(error, response);
        setLastRequestState(serviceError);
      });
  } else {
    console.error('It is not a 422', response);
    setLastRequestState(serviceError);
    return Promise.resolve();
  }
};

export const mapAmountIntoCard = (amounts) =>
  amounts.length
    ? amounts.map((a) => ({
        id: `gc${a.price}`,
        value: a.price,
        label: `$${a.price}`,
      }))
    : [];
